import { Box, Typography } from "@mui/material";
import { IUserCardProps } from "./types";
import { stringAvatar } from "src/lib/utils/strToAvatar";
import { Avatar } from "../../basics";

const AVATAR_SIZE = 36;

const UserCard = (props: IUserCardProps) => (
    <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", alignItems: "center", gap: 1.5, minWidth: 0 }}>
        <Avatar src={props.avatarSrc} sx={{ width: AVATAR_SIZE, height: AVATAR_SIZE, flexShrink: 0 }}>
            {stringAvatar(props.avatarName ?? props.userName)}
        </Avatar>
        <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
            <Typography
                variant="body1"
                sx={{
                    fontWeight: (theme) => (theme as any).typography.weights.bold,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {props.userName}
            </Typography>
            <Typography
                variant="caption"
                sx={{
                    color: (theme) => (theme as any).palette.neutral.main,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {props.userPosition}
            </Typography>
        </Box>
    </Box>
)

export { UserCard, AVATAR_SIZE }
